var English = "英文";
var French = "法文";
var German = "德文";
var Italian = "義大利文";
var Japanese = "日文";
var Korean = "韓文";
var Portuguese = "葡萄牙文";
var Russian = "俄文";
var Spanish = "西班牙文";
var Bahasa = "馬來文";
var Thai = "泰文";
var Vietnamese = "越南文";
var Turkish = "土耳其文";
var Arabic = "阿拉伯文";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "簡體中文",
	"Chinese-Traditional": "繁體中文",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
